import { z as m, a as p, u as c } from "./useExposedProps-B8NHdNRq.js";
import { a as f } from "./hook-BkLXq8pm.js";
import { d as n, e as d } from "./ZudokuContext-BcqSiygJ.js";
import { C as k } from "./ZudokuContext-BcqSiygJ.js";
import { useState as E, useEffect as i } from "react";
function C(e, s) {
  const t = n(), [r, o] = E();
  return i(() => t.addEventListener(e, (...u) => {
    if (s) {
      const a = s(...u);
      o(a);
    } else
      o(u);
  }), [t, e, s]), r;
}
const A = C, v = m, z = p, L = c, M = f, P = n, S = d;
export {
  k as CACHE_KEYS,
  M as useAuth,
  S as useCache,
  A as useEvent,
  z as useExposedProps,
  L as useMDXComponents,
  v as useTheme,
  P as useZudoku
};
//# sourceMappingURL=zudoku.hooks.js.map
